import * as React from 'react';
import SVGUniqueID from 'react-svg-unique-id';

const OutlineInfoCircleIcon = () => (
  <SVGUniqueID>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
    >
      <path
        fill="#F87171"
        d="M10 18.958c-4.942 0-8.958-4.016-8.958-8.958S5.058 1.042 10 1.042 18.958 5.058 18.958 10 14.942 18.958 10 18.958zm0-16.666C5.75 2.292 2.292 5.75 2.292 10S5.75 17.708 10 17.708 17.708 14.25 17.708 10 14.25 2.292 10 2.292z"
      ></path>
      <path
        fill="#F87171"
        d="M10 11.458a.63.63 0 01-.625-.625V6.667A.63.63 0 0110 6.042a.63.63 0 01.625.625v4.166a.63.63 0 01-.625.625zM10 14.167a.829.829 0 01-.317-.067.963.963 0 01-.275-.175.86.86 0 01-.175-.275.83.83 0 01-.066-.317.83.83 0 01.066-.316c.042-.1.1-.192.175-.275a.96.96 0 01.275-.175.833.833 0 01.634 0c.1.041.191.1.275.175a.96.96 0 01.175.275c.041.1.066.208.066.316a.829.829 0 01-.066.317.86.86 0 01-.175.275.963.963 0 01-.275.175.829.829 0 01-.317.067z"
      ></path>
    </svg>
  </SVGUniqueID>
);

export { OutlineInfoCircleIcon };
